module.exports = __webpack_public_path__ + "static/media/pool-hall15.9d69014b.jpg";